import { faFilePdf as fasFilePdf } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { Config } from "@config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import type { ReactNode } from "react";
import { LandingContainer } from "./components/LandingContainer";

/**
 * @Routing
 *
 * @title "Panaszkezelési szabályzat"
 * @description "A Bankmonitor Partner Kft. panaszkezelési szabályzata."
 * @route "/panaszkezelesi-szabalyzat/"
 */

interface File {
	name: string;
	path: string;
}

const ARCHIVES: File[] = [
	// NOTE: Minden szabályzat feltöltésénél kötelező feltöltenünk az előzőt:
	// NOTE: ez az aktuális:
	// {
	// 	name: 'Panaszkezelési szabályzat 2022-12-02.pdf',
	// 	path: 'panaszkezelesi_szabalyzat_2022_12_02.pdf',
	// },
	{
		name: "Panaszkezelési szabályzat 2022-04-30.pdf",
		path: "panaszkezelesi_szabalyzat_2022_04_30.pdf",
	},
	{
		name: "Panaszkezelési szabályzat 2021-12-03.pdf",
		path: "panaszkezelesi_szabalyzat_2021_12_03.pdf",
	},
	{
		name: "Panaszkezelési szabályzat 2021-10-10.pdf",
		path: "panaszkezelesi_szabalyzat_2021_10_10.pdf",
	},
	{
		name: "Panaszkezelési szabályzat 2021-06-01.pdf",
		path: "panaszkezelesi_szabalyzat_2021_06_01.pdf",
	},
	{
		name: "Panaszkezelési szabályzat 2017-04-03.pdf",
		path: "panaszkezelesi_szabalyzat_2017_04_03.pdf",
	},
];

export default class Landing extends React.PureComponent {
	private renderArchives(): ReactNode {
		return (
			<>
				<h4 className="mt-5">Archív szabályzatok</h4>
				<ul className="list-unstyled">
					{ARCHIVES.map((file) => (
						<li key={file.name}>
							<a
								href={Config.buildSsrFriendlyUrl(
									"BM_BASE_DOCS_URL",
									`/public/panaszkezelesi-szabalyzat/archive/${file.path}`,
								)}
								download={file.name}
							>
								<FontAwesomeIcon icon={fasFilePdf} /> {file.name}
							</a>
						</li>
					))}
				</ul>
			</>
		);
	}

	public render(): ReactNode {
		return (
			<LandingContainer>
				<h1 className="mb-0">
					<strong>Panaszkezelési Szabályzat – Bankmonitor Partner Kft.</strong>
				</h1>
				<p className="mb-4">Hatályos 2022.12.02. napjától</p>
				<p>
					A <strong>Bankmonitor Partner Kft.</strong>, mint a <strong>435/2016. Kormányrendelet</strong>,
					valamint a <strong>66/2021. (XII. 20.) MNB rendelet</strong> hatálya alá tartozó{" "}
					<strong>szolgáltató</strong>, mint a hitelintézetekről és a pénzügyi vállalkozásokról szóló 2013.
					évi CCXXXVII. törvény (Hpt.) szerinti független közvetítő és a biztosítási tevékenységről szóló
					2014. évi LXXXVIII. törvény (Bit.) szerinti független biztosításközvetítő (a továbbiakban: „
					<strong>Bankmonitor</strong>”), ezen jogszabályoknak megfelelően az alábbi panaszkezelési
					szabályzatot teszi közzé azzal, hogy a jelen szabályzatban nem szabályozott kérdésekben a
					szolgáltató Üzletszabályzata és a vonatkozó jogszabályok irányadóak.
				</p>
				<ol className="pt-0">
					<li className="pt-5">
						Az Ügyfél a Bankmonitor pénzügyi közvetítői vagy biztosításközvetítői szolgáltatásával
						kapcsolatos észrevételeit, panaszait
						<br />
						<br />- személyesen munkanapokon a Bankmonitor ügyfélforgalom számára nyitva álló
						üzlethelyiségében (1037 Budapest, Montevideo utca 16/B.), a nyitvatartási idő alatt, azaz
						naponta 8 és 16 óra között;
						<br /> <br />- írásban a 1037 Budapest, Montevideo utca 16/B. címre küldött levélben;
						<br /> <br />- telefonon a 06-1-920-1420 telefonszámon hétfőn, kedden, csütörtökön és pénteken 8
						és 16 óra között, szerdai napon 8 és 20 óra között;
						<br /> <br />- a Bankmonitor honlapján (www.bankmonitor.hu) keresztül, elektronikus úton a
						bankmonitor@bankmonitor.hu e-mail címre történő elektronikus levélküldés által teheti meg saját
						nevében vagy meghatalmazott útján eljárva. Amennyiben az Ügyfél meghatalmazott útján jár el, a
						meghatalmazást közokiratba vagy teljes bizonyító erejű magánokiratba kell foglalni.
					</li>
					<li className="pt-5">
						Telefonon történő panaszkezelés esetén a Bankmonitor biztosítja az öt percen belüli várakozási
						időn belüli hívásfogadást és az ügyintézés megkezdését. Telefonon történő panaszkezelés esetén a
						Bankmonitor és az Ügyfél közötti telefonos kommunikációt a Bankmonitor – az Ügyfél erre
						vonatkozó előzetes figyelmeztetését követően – hangfelvétellel rögzíti, és a hangfelvételt öt
						évig megőrzi. Az Ügyfél kérésére biztosítani kell a hangfelvétel visszahallgatását, továbbá
						térítésmentesen rendelkezésre kell bocsátani a hangfelvételről készített hitelesített
						jegyzőkönyvet 15 napon belül.
					</li>
					<li className="pt-5">
						A Bankmonitor a szóbeli panaszt - az alábbi 4. pontban meghatározott eltéréssel - azonnal
						megvizsgálja, és szükség szerint orvosolja. Ha az Ügyfél a panasz kezelésével nem ért egyet, a
						Bankmonitor a panaszról és az azzal kapcsolatos álláspontjáról jegyzőkönyvet vesz fel, és annak
						egy másolati példányát a személyesen közölt szóbeli panasz esetén az Ügyfélnek átadja, telefonon
						közölt szóbeli panasz esetén az Ügyfélnek - az alábbi 5. pontban foglaltakkal egyidejűleg -
						megküldi, egyebekben az írásbeli panaszra vonatkozó rendelkezések szerint jár el. Az Ügyfél
						számára küldött jegyzőkönyv a Bankmonitor azonosító adatai mellett tartalmazza legalább az
						Ügyfél nevét, lakcímét vagy székhelyét, szükség esetén levelezési címét, a panasz
						előterjesztésének helyét, idejét, módját, a panasz részletes leírását a panasszal érintett
						kifogások elkülönítetten történő rögzítésével, a panasszal érintett szerződés számát, az Ügyfél
						által bemutatott iratok, dokumentumok és egyéb bizonyítékok jegyzékét, telefonon, telefaxon vagy
						e-mailen közölt panasz kivételével a jegyzőkönyvet felvevő személy és az ügyfél aláírását, a
						jegyzőkönyv felvételének helyét, idejét.
					</li>
					<li className="pt-5">
						Ha a panasz azonnali kivizsgálása nem lehetséges, a Bankmonitor a panaszról jegyzőkönyvet vesz
						fel, és annak egy másolati példányát a személyesen közölt szóbeli panasz esetén az Ügyfélnek
						átadja, telefonon közölt szóbeli panasz esetén az Ügyfélnek - az alábbi 5. pontban foglaltakkal
						egyidejűleg - megküldi, egyebekben az írásbeli panaszra vonatkozó rendelkezések szerint jár el.
					</li>
					<li className="pt-5">
						A Bankmonitor az írásbeli panasszal kapcsolatos, indokolással ellátott álláspontját a panasz
						közlését követő harminc napon belül a panasz előterjesztésére igénybe vett csatornával megegyező
						csatornán megküldi az Ügyfélnek.
						<br />
						<br />A Bankmonitor a panasszal kapcsolatos, indokolással ellátott álláspontját tartalmazó
						választ – az ügyfél eltérő rendelkezésének hiányában – elektronikus úton küldi meg, amennyiben a
						panaszt az Ügyfél
						<br />
						<br />
						a) a kapcsolattartás céljából bejelentett és a Bankmonitor által nyilvántartott elektronikus
						levelezési címről küldte, vagy
						<br />
						<br />
						b) a Bankmonitor által üzemeltetett, kizárólag az Ügyfél által hozzáférhető internetes portálon
						keresztül terjesztette elő.
						<br />
						<br />A válasz fenti elektronikus megküldése nem alkalmazható, amennyiben nem biztosítható, hogy
						a Bankmonitor a válaszát oly módon küldje meg az Ügyfél részére, amely alkalmas annak
						megállapítására, hogy a Bankmonitor a küldeményt kinek a részére és milyen értesítési címre
						küldte meg, emellett kétséget kizáróan igazolja a küldemény elküldésének tényét és időpontját
						is, vagy nem biztosítható a titokvédelmi szabályok által védett adatoknak azok megismerésére nem
						jogosult harmadik személyekkel szembeni védelem.
					</li>
					<li className="pt-5">
						A panasz elutasítása esetén a Bankmonitor válaszában tájékoztatja az Ügyfelet arról, hogy a
						Magyar Nemzeti Bankról szóló 2013. évi CXXXIX. törvény szerinti fogyasztóvédelmi rendelkezések
						megsértése esetén az MNB pénzügyi fogyasztóvédelmi tárgyú megkeresések fogadására kialakított
						ügyfélszolgálata előtt a vonatkozó formanyomtatvány kitöltésével fogyasztóvédelmi eljárást
						kezdeményezhet, vagy a szerződés létrejöttével, érvényességével, joghatásaival és megszűnésével,
						továbbá a szerződésszegéssel és annak joghatásaival kapcsolatos jogvita esetén bírósághoz
						fordulhat, vagy a Pénzügyi Békéltető Testület (cím: 1122 Budapest, Krisztina krt. 6.; levélcím:
						H-1525 Budapest Pf.:172.; telefonszám: +36-80-203-776; email cím: ugyfelszolgalat@mnb.hu)
						eljárását kezdeményezheti. A panaszra adott válasz külön is tartalmazza a Pénzügyi Békéltető
						Testület levelezési címét.
						<br />
						<br />A Bankmonitor felhívja az Ügyfél figyelmét, hogy a panasz elutasítása vagy a panasz
						kivizsgálására előírt 30 napos törvényi válaszadási határidő eredménytelen eltelte esetén a
						fogyasztónak minősülő ügyfél az alábbiakhoz fordulhat:
						<br />
						<br />
						a) Pénzügyi Békéltető Testülethez (cím: 1122 Budapest, Krisztina krt. 6.; levélcím: H-1525
						Budapest Pf.:172.; telefonszám: +36-80-203-776; email cím: ugyfelszolgalat@mnb.hu) a szerződés
						létrejöttével, érvényességével, joghatásaival és megszűnésével, továbbá a szerződésszegéssel és
						annak joghatásaival kapcsolatos jogvita esetén;
						<br />
						<br />
						b) az MNB pénzügyi fogyasztóvédelmi tárgyú megkeresések fogadására kialakított
						ügyfélszolgálatához (Cím: 1122 Budapest, Krisztina krt. 6.; Telefon:+ 36 80 203 776; Fax:+ 36 1
						489 9102; Email: ugyfelszolgalat@mnb.hu; Levélcím:1534 Budapest BKKP Postafiók: 777., weboldal:
						https://www.mnb.hu/fogyasztovedelem/penzugyi-panasz);
						<br />
						<br />
						c) bírósághoz.
						<br />
						<br />A panasz elutasítása vagy a panasz kivizsgálására előírt 30 naptári napos törvényi
						válaszadási határidő eredménytelen eltelte esetén a fogyasztónak nem minősülő ügyfél bírósághoz
						fordulhat.
						<br />
						<br />A Bankmonitor tájékoztatja a fogyasztónak minősülő ügyfelet, hogy a panasz elutasítása
						vagy a panasz kivizsgálására előírt 30 naptári napos törvényi válaszadási határidő eredménytelen
						eltelte esetén a fogyasztó a Bankmonitortól a Pénzügyi Békéltető Testület, illetve a MNB
						pénzügyi fogyasztóvédelmi tárgyú megkeresések fogadására kialakított ügyfélszolgálat előtt
						megindítható eljárás alapjául szolgáló kérelem nyomtatvány megküldését igényelheti
					</li>
					<li className="pt-5">
						A Bankmonitor a panaszt és az arra adott választ öt évig őrzi meg, és azt az MNB kérésére
						bemutatja.
					</li>
					<li className="pt-5">
						A Bankmonitor az Ügyfelek panaszairól, valamint az azok rendezését, megoldását szolgáló
						intézkedésekről nyilvántartást vezet. Ezen nyilvántartásnak tartalmaznia kell
						<br />
						<br />
						a) a panasz leírását, a panasz tárgyát képező esemény vagy tény megjelölését,
						<br />
						<br />
						b) a panasz benyújtásának időpontját,
						<br />
						<br />
						c) a panasz rendezésére vagy megoldására szolgáló intézkedés leírását, elutasítás esetén annak
						indokát,
						<br />
						<br />
						d) a c) pont szerinti intézkedés teljesítésének határidejét és a végrehajtásért felelős személy
						megnevezését, továbbá
						<br />
						<br />
						e) a panasz megválaszolásának időpontját.
						<br />
						<br />A Bankmonitor a panaszokról vezetett nyilvántartás alapján a panaszokat nyomon követi, és
						<br />
						<br />
						a) legalább évente azokat témájuk szerint csoportosítja,
						<br />
						<br />
						b) a panasz okát képező tényeket és eseményeket feltárja, azonosítja,
						<br />
						<br />
						c) megvizsgálja, hogy a b) pontban rögzített tények és események hatással lehetnek-e más
						eljárásra, termékre vagy szolgáltatásra,
						<br />
						<br />
						d) eljárást kezdeményez a feltárt, b) pontban rögzített tények és események korrekciójára, és
						<br />
						<br />
						e) összefoglalja az ismétlődő vagy rendszerszintű problémákat, jogi kockázatokat.
					</li>
					<li className="pt-5">
						A Bankmonitor a panasz kivizsgálásáért az Ügyféllel szemben külön díjat nem számíthat fel.
					</li>
					<li className="pt-5">
						A Bankmonitor a panaszkezelés során különösen a következő adatokat kérheti az Ügyféltől:
						<br />
						<br />
						a) neve,
						<br />
						<br />
						b) szerződésszám, ügyfélszám, illetve pénztári azonosító,
						<br />
						<br />
						c) lakcíme, székhelye, levelezési címe,
						<br />
						<br />
						d) telefonszáma,
						<br />
						<br />
						e) értesítés módja,
						<br />
						<br />
						f) panasszal érintett termék vagy szolgáltatás,
						<br />
						<br />
						g) panasz leírása, oka,
						<br />
						<br />
						h) a panasz alátámasztásához szükséges, az ügyfél birtokában lévő olyan dokumentumok másolata,
						amely a szolgáltatónál nem áll rendelkezésre,
						<br />
						<br />
						i) meghatalmazott útján eljáró ügyfél esetében érvényes meghatalmazás és
						<br />
						<br />
						j) a panasz kivizsgálásához, megválaszolásához szükséges egyéb adat.
						<br />
						<br />A panaszt benyújtó ügyfél adatait a Bankmonitor az Adatvédelmi szabályzatának (
						{Config.getBankmonitorUrl("/adatvedelem/")}) megfelelően kezeli.
					</li>
					<li className="pt-5">
						Az Ügyfél a Bankmonitor által közvetített pénzügyi vagy biztosítási szolgáltatással kapcsolatos,
						az adott pénzügyi vagy biztosítási szolgáltatást nyújtó pénzügyi intézményre vagy biztosítóra
						vonatkozó észrevételeit, panaszait a közvetített pénzügyi szolgáltatást nyújtó pénzügyi
						intézménynél vagy biztosítónál teheti meg. Amennyiben a Bankmonitorhoz érkezik ilyen tartalmú
						panasz, úgy azt a Bankmonitor 3 munkanapon belül továbbítja a pénzügyi intézmény vagy a
						biztosító részére.
						<br />A Bankmonitor azokat a panaszokat, melyet a Bankmonitor magatartására, tevékenységére vagy
						mulasztására vonatkoznak, saját maga kezeli.
					</li>
					<li className="pt-5">
						A Bankmonitor fogyasztóvédelmi ügyekért felelős kapcsolattartója Sándorfi Balázs. A
						fogyasztóvédelmi ügyekért felelős kapcsolattartó személyének változását a Bankmonitor 15 napon
						belül bejelenti.
					</li>
				</ol>

				{this.renderArchives()}
			</LandingContainer>
		);
	}
}
